import { ChakraProvider } from "@chakra-ui/react";
import { initReact, ErrorBoundary } from "@neoworlder2/sentry/react";
import { captureException } from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import "./css/config.css";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import router from "./routes/index.tsx";
import store from "./store/index.ts";
import chakraTheme from "./utils/chakra-theme.ts";

initReact({
    service: "ai-node-builder",
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT
});
captureException(new Error("[SENTRY-TEST:] ai-node-builder started — delete this line"));

// eslint-disable-next-line no-undef
ReactDOM.createRoot(document.getElementById("app")!).render(
    <React.StrictMode>
        <Provider store={store}>
            <ChakraProvider theme={chakraTheme}>
                <ErrorBoundary fallback={<p>An unexpected error occurred.</p>}>
                    <RouterProvider router={router} />
                </ErrorBoundary>
                <Toaster
                    position="bottom-center"
                    toastOptions={{
                        // Define default options
                        className: "bg-black text-white",
                        duration: 5000,
                        style: {
                            background: "#363636",
                            color: "#fff"
                        }
                    }}
                />
            </ChakraProvider>
        </Provider>
    </React.StrictMode>
);
